/* Once Upon Magic — NEO 2026
   Product-page progressive enhancements.
   Presentation only: variants, price, cart, availability and app logic stay untouched. */
(() => {
  const main = document.querySelector('main[data-template]');
  const template = (main?.dataset.template || '').split('.')[0];
  if (template !== 'product' && !window.location.pathname.includes('/products/')) return;

  const locale = (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  const copy = {
    fr: { eyebrow: 'Le produit en détail', heading: 'À propos de cette pièce', open: 'Lire la description complète', close: 'Réduire la description', swipe: 'Glissez pour explorer' },
    en: { eyebrow: 'Product details', heading: 'About this piece', open: 'Read the full description', close: 'Show less', swipe: 'Swipe to explore' },
    de: { eyebrow: 'Produktdetails', heading: 'Mehr über dieses Stück', open: 'Vollständige Beschreibung lesen', close: 'Weniger anzeigen', swipe: 'Wischen zum Entdecken' },
    es: { eyebrow: 'Detalles del producto', heading: 'Sobre esta pieza', open: 'Leer la descripción completa', close: 'Mostrar menos', swipe: 'Desliza para explorar' },
    it: { eyebrow: 'Dettagli prodotto', heading: 'A proposito di questo articolo', open: 'Leggi la descrizione completa', close: 'Mostra meno', swipe: 'Scorri per esplorare' },
    nl: { eyebrow: 'Productdetails', heading: 'Over dit item', open: 'Lees de volledige beschrijving', close: 'Minder tonen', swipe: 'Swipe om te ontdekken' }
  }[locale] || { eyebrow: 'Product details', heading: 'About this piece', open: 'Read the full description', close: 'Show less', swipe: 'Swipe to explore' };

  const enhanceGallery = () => {
    const gallery = document.querySelector('.product-information__media media-gallery');
    if (!gallery || gallery.dataset.oumGalleryReady === 'true') return;
    const slides = [...gallery.querySelectorAll('slideshow-slide.product-media-container')];
    if (slides.length < 2) return;
    gallery.dataset.oumGalleryReady = 'true';

    const counter = document.createElement('div');
    counter.className = 'oum-product-gallery-counter';
    counter.setAttribute('aria-live', 'polite');
    counter.innerHTML = '<span data-oum-gallery-current>01</span><i aria-hidden="true"></i><span data-oum-gallery-total></span>';
    counter.querySelector('[data-oum-gallery-total]').textContent = String(slides.length).padStart(2, '0');
    gallery.appendChild(counter);

    const hint = document.createElement('div');
    hint.className = 'oum-product-gallery-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = `<span>↔</span>${copy.swipe}`;
    gallery.appendChild(hint);

    const setCurrent = () => {
      let index = slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false' || slide.getAttribute('aria-current') === 'true');
      if (index < 0) index = 0;
      counter.querySelector('[data-oum-gallery-current]').textContent = String(index + 1).padStart(2, '0');
    };
    setCurrent();
    if ('MutationObserver' in window) {
      const observer = new MutationObserver(setCurrent);
      slides.forEach((slide) => observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden', 'aria-current'] }));
    }
    const dismissHint = () => hint.classList.add('is-dismissed');
    gallery.addEventListener('pointerdown', dismissHint, { once: true, passive: true });
    gallery.addEventListener('keydown', dismissHint, { once: true });
  };

  const boot = () => {
    enhanceGallery();
    document.documentElement.classList.add('oum-product-experience-ready');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
